export default "__VITE_ASSET__BvnecHcG__"